<template lang="pug">
  .component-create-entity-button
    ModalReveal()
      button.button.success(slot="trigger") Uncovered amount
      .row
        .column
          h2 hello


      //ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel


</template>

<script>
  import DatePicker from '../../components/structure/DatePicker'
  import StartEndTimePicker from './StartEndTimePicker'
  import ModalReveal from '../../components/structure/foundation/ModalReveal'
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'
  import ActionButton from '../../components/structure/ui/ActionButton'
  import SelectizeCommonCost from '../../components/structure/ui/lists/selectize/SelectizeCommonCost'

  export default {
    name: 'ReservationUncoveredAmountReveal',
    components: {SelectizeCommonCost, ActionButton, ModalReveal, StartEndTimePicker, DatePicker},
    data() {
      return {
        body: {
          code: null,
          start: null,
          end: null,
          max_uses: null,
          max_days: null,
          common_cost_id: null,
        }
      }
    },
    created() {
      if (this.couponProp !== null) {
        for (let key in this.couponProp) {
          if (key === 'common_cost') {
            this.body.common_cost_id = this.couponProp.common_cost.id
          } else {
            this.body[key] = this.couponProp[key]
          }

        }
      }
    },
    methods: {
      setCommonCost(obj) {
        this.body.common_cost_id = obj.id
      },
      save() {

      }
    },
    computed: {
 componentId() {
        return this.couponProp !== null ? `voidReveal-${this.couponProp.id}` : `voidReveal-${this._uid}`
      },
    },
    props: {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ReservationUncoveredAmount.vue?a4144c68